import { useQuery } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useLanguages = (projectId) => {
  const fetchContext = useContext(FetchContext);

  return useQuery(["project", projectId.toString(), "languages"], async () => {
    const { data } = await fetchContext.authAxios.get(
      `/projects/${projectId}/languages`
    );
    return data;
  });
};
